<template>
    <div>
        <div class="ivu-mb-8">
            <Image :src="banner" width="100%">
                <template #error>
                    <Icon type="ios-image-outline" size="24" color="#ccc"/>
                </template>
            </Image>
        </div>
        <div>
            <div class="ivu-mb-8">
                <Card class="ivu-pl-8 ivu-pr-8">
                    <Space direction="vertical" size="large">
                        <Space split>
                            <Text>收入资源：
                                <Text strong>
                                    <CountUp :end="totalNumberOfResources" :duration="1"/>
                                </Text>
                            </Text>
                            <Text v-if="userinfo">欢迎，{{ userinfo.username }}</Text>
                            <Text v-if="isVIPExpired">
                                <Poptip style="text-align: center;" trigger="hover" title="VIP剩余时间"
                                        :content="remainingVipTime" placement="bottom">
                                    VIP有效期：{{ userinfo.viptime }}
                                </Poptip>
                            </Text>
                            <Text v-if="isVIPExpired">
                                <Poptip style="text-align: center;" trigger="hover" title="VIP尊享免费下载"
                                        :content="`已使用 ${orderTodayCount}/${dailyFrequency}`" placement="bottom">
                                    今日免费下载次数：{{ remainingDownloads }}
                                </Poptip>
                            </Text>
                            <Link v-if="service" :to="service" target="_blank">联系客服</Link>
                            <Link to="messageForCode">留言求码</Link>
<!--                            <Link underline type="warning" v-if="userinfo" @click="logOut">退出登录</Link>-->
                        </Space>
                    </Space>

                    <Space direction="vertical" size="large" class="ivu-fr">
                        <Space split>
                            <Link underline type="warning" v-if="userinfo" @click="logOut">退出登录</Link>
                            <Link to="login" v-if="!userinfo">登录</Link>
                            <Link to="register" v-if="!userinfo">注册</Link>
                        </Space>
                    </Space>
                </Card>
            </div>
            <div>
                <Menu mode="horizontal" theme="light" active-name="1" @on-select="handleSelect">
                    <MenuItem name="all-all" to="/">首页</MenuItem>
                    <Submenu name="玖富圈">
                        <template #title>玖富圈</template>
                        <MenuItem name="玖富圈-all">全部</MenuItem>
                        <MenuItem name="玖富圈-网站源码">网站源码</MenuItem>
                        <MenuItem name="玖富圈-绿色软件">绿色软件</MenuItem>
                        <MenuItem name="玖富圈-棋牌源码">棋牌源码</MenuItem>
                        <MenuItem name="玖富圈-帝国CMS">帝国CMS</MenuItem>
                        <MenuItem name="玖富圈-织梦模板">织梦模板</MenuItem>
                        <MenuItem name="玖富圈-织梦模板">织梦模板</MenuItem>
                        <MenuItem name="玖富圈-其它模板">其它模板</MenuItem>
                        <MenuItem name="玖富圈-易优模板">易优模板</MenuItem>
                        <MenuItem name="玖富圈-Pbootcms">Pbootcms</MenuItem>
                    </Submenu>
                    <Submenu name="源码当先">
                        <template #title>源码当先</template>
                        <MenuItem name="源码当先-all">全部</MenuItem>
                        <MenuItem name="源码当先-模板源码">模板源码</MenuItem>
                        <MenuItem name="源码当先-微信源码">微信源码</MenuItem>
                        <MenuItem name="源码当先-棋牌源码">棋牌源码</MenuItem>
                        <MenuItem name="源码当先-BC">BC</MenuItem>
                        <MenuItem name="源码当先-H5">H5</MenuItem>
                        <MenuItem name="源码当先-端游">端游</MenuItem>
                        <MenuItem name="源码当先-手游">手游</MenuItem>
                        <MenuItem name="源码当先-游戏源码">游戏源码</MenuItem>
                        <MenuItem name="源码当先-app源码">app源码</MenuItem>
                        <MenuItem name="源码当先-网站源码">网站源码</MenuItem>
                        <MenuItem name="源码当先-插件">插件</MenuItem>
                    </Submenu>
                    <Submenu name="NSXU源码社">
                        <template #title>NSXU源码社</template>
                        <MenuItem name="NSXU源码社-all">全部</MenuItem>
                        <MenuItem name="NSXU源码社-其他源码">其他源码</MenuItem>
                        <MenuItem name="NSXU源码社-支付源码">支付源码</MenuItem>
                        <MenuItem name="NSXU源码社-小程序">小程序</MenuItem>
                        <MenuItem name="NSXU源码社-PHP源码">PHP源码</MenuItem>
                        <MenuItem name="NSXU源码社-企业源码">企业源码</MenuItem>
                        <MenuItem name="NSXU源码社-商城源码">商城源码</MenuItem>
                        <MenuItem name="NSXU源码社-区块链源码">区块链源码</MenuItem>
                        <MenuItem name="NSXU源码社-分销源码">分销源码</MenuItem>
                        <MenuItem name="NSXU源码社-网站源码">网站源码</MenuItem>
                        <MenuItem name="NSXU源码社-发卡源码">发卡源码</MenuItem>
                        <MenuItem name="NSXU源码社-图片源码">图片源码</MenuItem>
                        <MenuItem name="NSXU源码社-下载站源码">下载站源码</MenuItem>
                        <MenuItem name="NSXU源码社-电影源码">电影源码</MenuItem>
                    </Submenu>
                    <Submenu name="蜜桃源码网">
                        <template #title>蜜桃源码网</template>
                        <MenuItem name="蜜桃源码网-all">全部</MenuItem>
                        <MenuItem name="蜜桃源码网-APP源码">APP源码</MenuItem>
                        <MenuItem name="蜜桃源码网-其他源码">其他源码</MenuItem>
                        <MenuItem name="蜜桃源码网-小程序">小程序</MenuItem>
                        <MenuItem name="蜜桃源码网-娱乐源码1">娱乐源码1</MenuItem>
                        <MenuItem name="蜜桃源码网-bc源码">bc源码</MenuItem>
                        <MenuItem name="蜜桃源码网-微信功能板块">微信功能板块</MenuItem>
                        <MenuItem name="蜜桃源码网-区块链">区块链</MenuItem>
                        <MenuItem name="蜜桃源码网-支付源码">支付源码</MenuItem>
                        <MenuItem name="蜜桃源码网-网站源码">网站源码</MenuItem>
                        <MenuItem name="蜜桃源码网-工具">工具</MenuItem>
                        <MenuItem name="蜜桃源码网-影视直播">影视直播</MenuItem>
                        <MenuItem name="蜜桃源码网-网站板块">网站板块</MenuItem>
                        <MenuItem name="蜜桃源码网-小说源码">小说源码</MenuItem>
                        <MenuItem name="蜜桃源码网-视频教程">视频教程</MenuItem>
                        <MenuItem name="蜜桃源码网-综合资讯">综合资讯</MenuItem>
                        <MenuItem name="蜜桃源码网-游戏源码">游戏源码</MenuItem>
                        <MenuItem name="蜜桃源码网-其他游戏">其他游戏</MenuItem>
                    </Submenu>
                    <Submenu name="源码屋">
                        <template #title>源码屋</template>
                        <MenuItem name="源码屋-all">全部</MenuItem>
                        <MenuItem name="源码屋-功能源码">功能源码</MenuItem>
                        <MenuItem name="源码屋-网站源码">网站源码</MenuItem>
                        <MenuItem name="源码屋-软件工具">软件工具</MenuItem>
                        <MenuItem name="源码屋-游戏源码">游戏源码</MenuItem>
                        <MenuItem name="源码屋-区块链类">区块链类</MenuItem>
                        <MenuItem name="源码屋-影视小说">影视小说</MenuItem>
                        <MenuItem name="源码屋-视频直播">视频直播</MenuItem>
                        <MenuItem name="源码屋-支付平台">支付平台</MenuItem>
                        <MenuItem name="源码屋-网站模板">网站模板</MenuItem>
                        <MenuItem name="源码屋-理财互助">理财互助</MenuItem>
                        <MenuItem name="源码屋-红包扫雷">红包扫雷</MenuItem>
                        <MenuItem name="源码屋-金融源码">金融源码</MenuItem>
                        <MenuItem name="源码屋-热门资源">热门资源</MenuItem>
                        <MenuItem name="源码屋-股票期货">股票期货</MenuItem>
                        <MenuItem name="源码屋-社交源码">社交源码</MenuItem>
                        <MenuItem name="源码屋-商城源码">商城源码</MenuItem>
                        <MenuItem name="源码屋-源码代售">源码代售</MenuItem>
                        <MenuItem name="源码屋-双轨直销">双轨直销</MenuItem>
                        <MenuItem name="源码屋-模块插件">双轨直销</MenuItem>
                        <MenuItem name="源码屋-小程序模板">小程序模板</MenuItem>
                        <MenuItem name="源码屋-电子商务">电子商务</MenuItem>
                        <MenuItem name="源码屋-主题模板">主题模板</MenuItem>
                        <MenuItem name="源码屋-IT技术学院">IT技术学院</MenuItem>
                        <MenuItem name="源码屋-站长资源">站长资源</MenuItem>
                    </Submenu>
                    <Submenu name="八爷源码">
                        <template #title>八爷源码</template>
                        <MenuItem name="八爷源码-all">全部</MenuItem>
                        <MenuItem name="八爷源码-棋牌教程">棋牌教程</MenuItem>
                        <MenuItem name="八爷源码-区块链源码">区块链源码</MenuItem>
                        <MenuItem name="八爷源码-房卡约战类">房卡约战类</MenuItem>
                        <MenuItem name="八爷源码-金币电玩类">金币电玩类</MenuItem>
                        <MenuItem name="八爷源码-休闲娱乐">休闲娱乐</MenuItem>
                        <MenuItem name="八爷源码-金融理财">金融理财</MenuItem>
                        <MenuItem name="八爷源码-菠菜源码">菠菜源码</MenuItem>
                        <MenuItem name="八爷源码-客服通讯">客服通讯</MenuItem>
                        <MenuItem name="八爷源码-精品源码">精品源码</MenuItem>
                        <MenuItem name="八爷源码-打赏源码">打赏源码</MenuItem>
                        <MenuItem name="八爷源码-整站源码">整站源码</MenuItem>
                        <MenuItem name="八爷源码-真金竞技类">真金竞技类</MenuItem>
                        <MenuItem name="八爷源码-棋牌技术">棋牌技术</MenuItem>
                        <MenuItem name="八爷源码-棋牌素材">棋牌素材</MenuItem>
                        <MenuItem name="八爷源码-支付源码">支付源码</MenuItem>
                        <MenuItem name="八爷源码-H5棋牌源码">H5棋牌源码</MenuItem>
                        <MenuItem name="八爷源码-商城源码">商城源码</MenuItem>
                        <MenuItem name="八爷源码-微盘源码">微盘源码</MenuItem>
                        <MenuItem name="八爷源码-精品软件">精品软件</MenuItem>
                        <MenuItem name="八爷源码-常用工具">常用工具</MenuItem>
                        <MenuItem name="八爷源码-破解授权">破解授权</MenuItem>
                        <MenuItem name="八爷源码-分发源码">分发源码</MenuItem>
                        <MenuItem name="八爷源码-技术文章">技术文章</MenuItem>
                        <MenuItem name="八爷源码-模板插件">模板插件</MenuItem>
                        <MenuItem name="八爷源码-其它网站">其它网站</MenuItem>
                        <MenuItem name="八爷源码-技能培训">技能培训</MenuItem>
                        <MenuItem name="八爷源码-手游端游">手游端游</MenuItem>
                        <MenuItem name="八爷源码-棋牌网站">棋牌网站</MenuItem>
                        <MenuItem name="八爷源码-精品教程">精品教程</MenuItem>
                        <MenuItem name="八爷源码-商业服务">商业服务</MenuItem>
                        <MenuItem name="八爷源码-工具软件">工具软件</MenuItem>
                        <MenuItem name="八爷源码-新闻资讯">新闻资讯</MenuItem>
                    </Submenu>
                    <Submenu name="天美社区">
                        <template #title>天美社区</template>
                        <MenuItem name="天美社区-all">全部</MenuItem>
                        <MenuItem name="天美社区-亲测专区">亲测专区</MenuItem>
                        <MenuItem name="天美社区-BC/QP">BC/QP</MenuItem>
                        <MenuItem name="天美社区-区块币圈">区块币圈</MenuItem>
                        <MenuItem name="天美社区-其他源码">其他源码</MenuItem>
                        <MenuItem name="天美社区-商业互换">商业互换</MenuItem>
                        <MenuItem name="天美社区-精品教程">精品教程</MenuItem>
                        <MenuItem name="天美社区-支付源码">支付源码</MenuItem>
                        <MenuItem name="天美社区-小程序">小程序</MenuItem>
                        <MenuItem name="天美社区-影视直播">影视直播</MenuItem>
                        <MenuItem name="天美社区-商城源码">商城源码</MenuItem>
                        <MenuItem name="天美社区-手游端游">手游端游</MenuItem>
                        <MenuItem name="天美社区-博客主题">博客主题</MenuItem>
                        <MenuItem name="天美社区-程序源码">程序源码</MenuItem>
                        <MenuItem name="天美社区-工具文档">工具文档</MenuItem>
                        <MenuItem name="天美社区-主题模板">主题模板</MenuItem>
                        <MenuItem name="天美社区-网站模板">网站模板</MenuItem>
                        <MenuItem name="天美社区-企业主题">企业主题</MenuItem>
                    </Submenu>
                    <Submenu name="吾索源码网">
                        <template #title>吾索源码网</template>
                        <MenuItem name="吾索源码网-all">全部</MenuItem>
                        <MenuItem name="吾索源码网-网站源码">网站源码</MenuItem>
                        <MenuItem name="吾索源码网-APP源码">APP源码</MenuItem>
                        <MenuItem name="吾索源码网-网站插件">网站插件</MenuItem>
                        <MenuItem name="吾索源码网-网站模板">网站模板</MenuItem>
                        <MenuItem name="吾索源码网-游戏源码">游戏源码</MenuItem>
                        <MenuItem name="吾索源码网-工具/视频">工具/视频</MenuItem>
                    </Submenu>
                    <MenuItem name="vip~加入会员" to="/vip">
                        <Icon type="ios-people"/>
                        加入VIP
                    </MenuItem>
                    <MenuItem name="order~查看订单" to="/order">
                        <Icon type="ios-stats"/>
                        查看订单
                    </MenuItem>
<!--                    <MenuItem name="login~登录" to="/login">-->
<!--                        <Icon type="md-person"/>-->
<!--                        登录-->
<!--                    </MenuItem>-->
                </Menu>
            </div>
            <div class="ivu-pl-16 ivu-m-8">
                <Breadcrumb>
                    <BreadcrumbItem :to="breadcrumbItem.link" v-for="breadcrumbItem in breadcrumbItems"
                                    :key="breadcrumbItem.name" @click="loadBreadcrumbFromStorage(breadcrumbItem.link)">{{ breadcrumbItem.name }}
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div>
                <keep-alive>
                    <router-view/>
                </keep-alive>
            </div>
        </div>

        <BackTop :height="300" :bottom="100" :right="100">
            <Icon type="md-arrow-round-up" style="background-color: #808695;border-radius: 10%"/>
        </BackTop>
    </div>
</template>

<script>
import {
    onBeforeMount,
    onMounted,
    onBeforeUpdate,
    onUpdated,
    onBeforeUnmount,
    onUnmounted,
    onErrorCaptured,
    onRenderTracked,
    onRenderTriggered,
    onActivated,
    onDeactivated,
    inject,
    computed,
    ref
} from 'vue'
import {Card, Image, Text, Message, Modal} from "view-ui-plus";
import {useRoute} from 'vue-router';

export default {
    name: "app",
    // import 引入的组件需要注入到对象中才能使用
    components: {Text, Card, Image},
    props: {},
    // 计算属性 类似于 data 概念
    computed: {},
    // 监控 data 中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    setup() {
        const axios = inject('$axios') // 网络请求组件
        const banner = ref(null) // banner图
        const breadcrumbItems = ref([]); // 面包屑
        const route = useRoute(); // 路由
        const totalNumberOfResources = ref(''); // 资源总数
        const userinfo = ref(null); // 用户信息
        const orderTodayCount = ref(null);// 今天用了多少次vip权限下载
        const dailyFrequency = ref(null); // 用户VIP次数
        const service = ref(''); // 客服 链接
        // const router = useRouter()
        onBeforeMount(() => {
            // 初始化用户信息
            userinfo.value = JSON.parse(localStorage.getItem('userinfo'));
            console.log("用户信息", userinfo.value);
            // 监听面包屑改动
            window.addEventListener('updateBreadcrumb', updateBreadcrumbHandler);
            // 如果当前路由是首页，则初始化面包屑
            console.log("route.path", route.path);
            // if (route.path === '/') {
            //     // 加载初始面包屑信息
            //     loadBreadcrumbFromStorage();
            // }
            // 加载初始面包屑信息
            loadBreadcrumbFromStorage();
            getLogo(); // 获取logo信息
            totalNumberOfQueryResources(); // 查询资源总数
            orderToday(); // 查询今日使用VIP权限下载过多少次
        });// 生命周期 - 挂载之前
        onMounted(() => {
        })// 生命周期 - 挂载完成（可以访问 DOM 元素）
        onBeforeUpdate(() => {
        })// 生命周期 - 更新之前
        onUpdated(() => {
        })// 生命周期 - 更新之后
        onBeforeUnmount(() => {
        })// 生命周期 - 销毁之前
        onUnmounted(() => {
            // 在组件销毁时移除监听器
            window.removeEventListener('updateBreadcrumb', updateBreadcrumbHandler);
        })// 生命周期 - 销毁完成
        onErrorCaptured((err) => {
            console.log("生命周期钩子抛出错误", err);
        })// 当事件处理程序或生命周期钩子抛出错误时
        onRenderTracked((e) => {
            console.log("渲染追踪", e);
        })// 渲染的时候可以追踪到
        onRenderTriggered((e) => {
            console.log("重新渲染", e);
        })// 重新渲染的时候触发
        // 如果页面有 keep-alive 缓存功能,这个两个函数会触发
        onActivated(() => {
        })//进入的时候触发
        onDeactivated(() => {
        })//离开的时候触发
        // 点击菜单生成面包屑
        const generateBreadcrumb = (name) => {
            if (name.includes("-")) {
                const menuItems = name.split("-");
                const newBreadcrumbItems = [
                    {name: "首页", link: "/"},
                    {name: menuItems[0].replace("all", "全部分类"), link: ''},
                    {name: menuItems[1].replace("all", "全部"), link: ''}
                ];
                breadcrumbItems.value = newBreadcrumbItems;
                sessionStorage.setItem('breadcrumbItems', JSON.stringify(newBreadcrumbItems));
            }
        };
        // 页面初始化面包屑
        const loadBreadcrumbFromStorage = (link) => {
            const storedBreadcrumb = sessionStorage.getItem('breadcrumbItems');
            if (storedBreadcrumb && link!='/') {
                breadcrumbItems.value = JSON.parse(storedBreadcrumb);
            } else {
                const newBreadcrumbItems = [
                    {name: "首页", link: "/"},
                    {name: "全部分类", link: ""},
                    {name: "全部", link: ""},
                ];
                breadcrumbItems.value = newBreadcrumbItems;
            }
        };
        // 异步面包屑处理事件
        const updateBreadcrumbHandler = (event) => {
            // 更新面包屑
            const newBreadcrumbItems = event.detail;
            breadcrumbItems.value = newBreadcrumbItems;
            // 存储更新后的面包屑信息到sessionStorage
            sessionStorage.setItem('breadcrumbItems', JSON.stringify(newBreadcrumbItems));
        }
        // 获取logo
        const getLogo = () => {
            axios.post('admin/api/index/getLogo.html')
                .then(res => {
                    banner.value = res.data.data.banner;
                    console.log("banner", res.data.data.banner);
                });
            // 获取客服信息
            axios.post('admin/api/index/getService.html')
                .then(res => {
                    service.value = res.data.data.webCustomerService;
                });
        }
        // 查询资源总数
        const totalNumberOfQueryResources = () => {
            axios.post('admin/api/index/totalNumberOfQueryResources.html')
                .then(res => {
                    totalNumberOfResources.value = res.data.data.totalNumberOfResources;
                    console.log("资源总数", totalNumberOfResources.value);
                });
        }
        // 查询今日使用VIP权限下载过多少次
        const orderToday = () => {
            //如果用户数据为null
            if (!userinfo.value) return
            axios.post('admin/api/index/orderToday.html', '', {headers: {'token': userinfo.value.token}})
                .then(res => {
                    dailyFrequency.value = res.data.data.dailyFrequency;
                    orderTodayCount.value = res.data.data.orderTodayCount;
                    localStorage.setItem('orderTodayCount', orderTodayCount.value);
                    console.log("用户VIP总次数", dailyFrequency.value);
                    console.log("今日已使用", orderTodayCount.value);
                });
        }
        // 计算属性：判断用户VIP是否到期
        const isVIPExpired = computed(() => {
            if (!userinfo.value || !userinfo.value.viptime) {
                return false; // 用户信息或VIP到期时间不存在，返回false
            }
            const viptime = new Date(userinfo.value.viptime); // 转换VIP到期时间为Date对象
            const currentTime = new Date(); // 获取当前时间
            return viptime > currentTime; // 判断VIP到期时间是否早于当前时间，如果是则表示已到期
        });
        // 计算属性：计算剩余的VIP时间
        const remainingVipTime = computed(() => {
            if (!userinfo.value || !userinfo.value.viptime) {
                return ''; // 如果用户信息或VIP到期时间不存在，返回空字符串
            }
            const viptime = new Date(userinfo.value.viptime); // 转换VIP到期时间为Date对象
            const currentTime = new Date(); // 获取当前时间
            const timeDifference = viptime - currentTime; // 计算剩余时间（毫秒）
            if (timeDifference <= 0) {
                return 'VIP已过期'; // VIP已过期
            } else {
                const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // 计算剩余天数
                const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算剩余小时数
                const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)); // 计算剩余分钟数
                return `${days}天 ${hours}小时 ${minutes}分钟`; // 格式化剩余时间
            }
        });
        // 计算vip用户剩余下载次数
        const remainingDownloads = computed(() => {
            // 总次数减去使用的次数
            return dailyFrequency.value - orderTodayCount.value;
            // if (isNaN(dailyFrequency.value) || isNaN(orderTodayCount.value)) {
            //     return ''; // 如果数据尚未加载完成，则返回空字符串
            // } else {
            //     return dailyFrequency.value - orderTodayCount.value;
            // }
        })
        // 退出登录
        const logOut = () => {
            Modal.confirm({
                title: '提示',
                content: '<p>确定要退出登录吗?</p>',
                onOk: () => {
                    // 删除用户信息
                    localStorage.removeItem('userinfo')
                    Message.success("已退出登录");
                    // router.push({ path: '/login' }) // 跳转
                    location.reload() // 刷新页面
                }
            });
        }
        // 选择切换菜单
        const handleSelect = (name) => {
            console.log("切换菜单", name);
            if (name.includes("-")) { // 改变home页面表格
                // 存储选中的菜单信息到sessionStorage
                sessionStorage.setItem('selectedMenu', name);
                // 生成面包屑
                generateBreadcrumb(name);
                // 触发 home 页面的 重新请求数据
                const event = new Event('menuSelected');
                window.dispatchEvent(event);
            } else {
                const menuItems = name.split("~");
                const newBreadcrumbItems = [
                    {name: "首页", link: "/"},
                    {name: menuItems[1], link: menuItems[0]},
                ];
                breadcrumbItems.value = newBreadcrumbItems;
                // 存储面包屑信息到sessionStorage
                sessionStorage.setItem('breadcrumbItems', JSON.stringify(newBreadcrumbItems));
            }
        };

        return {
            banner,
            breadcrumbItems,
            totalNumberOfResources,
            userinfo,
            isVIPExpired,
            remainingDownloads,
            dailyFrequency,
            orderTodayCount,
            remainingVipTime,
            service,
            logOut,
            loadBreadcrumbFromStorage,
            handleSelect
        }
    },
    metaInfo: {
        title: '牛牛资源网 | 高质量Web网页源码资源整合-小程序源码、游戏源码、H5源码',
        meta: [
            {
                name: 'keywords',
                content: 'Web网页源码, 小程序源码, 游戏源码, H5源码, 微信小程序源码, 免费源码, 牛牛资源网'
            },
            {
                name: 'description',
                content: '牛牛资源网--本网站提供高质量的Web网页源码资源整合，包括小程序、游戏、H5源码。VIP会员可享受更多特权。'
            }
        ]
    }

}
</script>

<style>
body {
    background-image: url("../public/white-waves.png");
}

#app {
    width: 1400px;
    margin: auto;
    padding: 10px 15px;
}

.ivu-menu-drop-list {
    max-height: 380px;
    overflow: auto;
}

*::-webkit-scrollbar {
    width: 5px;
}

*::-webkit-scrollbar-track {
    background: #ccc; /* 滚动条轨道背景色 */
}

*::-webkit-scrollbar-thumb {
    background: #999; /* 滚动条滑块背景色 */
}

*::-webkit-scrollbar-thumb:hover {
    background: #555; /* 鼠标悬停在滑块上时的背景色 */
}
</style>